<template>
  <div>
    <el-form-item label="占位内容">
      <el-input v-model="data.placeholder" placeholder="占位内容" maxlength="10"></el-input>
    </el-form-item>
    <el-form-item label="默认值">
      <el-input v-model="data.value" placeholder="默认值"></el-input>
    </el-form-item>
    <el-form-item label="最大长度">
      <el-input-number
        v-model="data.maxlength"
        controls-position="right"
        placeholder="最大长度"
      ></el-input-number>
    </el-form-item>
    <el-form-item label="是否只读">
      <el-switch v-model="data.readonly" @change="checkChangeReadOnly" :disabled="readonlyDisabled"></el-switch>
      <!-- <el-switch v-model="data.readonly" @change="checkChangeReadOnly" :disabled="data.readonly"></el-switch> -->
    </el-form-item>
    <el-form-item label="是否必填">
      <el-switch v-model="data.required" @change="checkChangeValid" :disabled="validDisabled"></el-switch>
      <!-- <el-switch v-model="data.required" @change="checkChangeValid" :disabled="data.required"></el-switch> -->
    </el-form-item>
    <el-form-item label="正则校验" v-if="data.required">
      <el-input v-model.lazy="data.pattern" placeholder="正则表达式"></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "config-input",
  props: ["data"],
  data() {
    return {
      validator: {
        required: null,
        pattern: null
      },
    };
  },
  methods: {
        checkChangeValid(val,index){
        // this.validDisabled=false;
        this.readonlyDisabled=false;
      console.log(val,index);
      this.readonlyDisabled = val;
    },
    checkChangeReadOnly(val,index){
        this.validDisabled=false;
        // this.readonlyDisabled=false;
      console.log(val,index);
      this.validDisabled = val;
    },

    generateRule() {
      const rules = [];
      Object.keys(this.validator).forEach((key) => {
        if (this.validator[key]) rules.push(this.validator[key]);
      });
      this.data.rules = rules;
    },
  },
  watch: {
    "data": function (val) {
      console.log("data===>",val);
      if(val.required){
        this.readonlyDisabled = true;
      }
      if(val.readonly){
        this.validDisabled = true;
      }
    },
    "data.label": function (val) {
      console.log(this.data);
      if (val)
        this.validator.required = {
          required: true,
          message: `请输入${this.data.label}`,
        };
      else this.validator.required = null;
      this.generateRule();
    },
    "data.required": function (val) {
      console.log(this.data);
      if (val){
        // console.log("this.readonlyDisabled = true;");
        // this.readonlyDisabled = true;
        
        this.validator.required = {
          required: true,
          message: `请输入${this.data.label}`,
        };
      }else this.validator.required = null;
      this.generateRule();
    },
    // "data.readonly": function (val) {
    //   console.log(this.data);
    //   if (val){
    //     console.log("this.validDisabled = true;");
    //     this.validDisabled = true;
    //   }
    // },
    "data.pattern": function (val) {
      if (val)
        this.validator.pattern = {
          pattern: new RegExp(val),
          message: `${this.data.label}格式不匹配`,
        };
      else this.validator.pattern = null;
      this.generateRule();
    },
  },
};
</script>
